import TYPES from '@/modules/shared/types';

// Domain
import { LinkSowosPocketRepository } from '../../domain/repositories/link-sowos-pocket-repository';
import { InvestorGoalsDto } from '../../domain/dtos/investor-goals-dto';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class LinkSowosPocketHttpRepository implements LinkSowosPocketRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/flagship/investor-goal/link-sowos-pocket/`;

  create(investor_goals_dto: InvestorGoalsDto): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint, 'POST', investor_goals_dto)
        .then((response) => {
          response.json()
            .then(({ success, data, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
